/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_State_DriedInputs */

const vi_tea_purchase_state_dried = /** @type {(inputs: Tea_Purchase_State_DriedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khô`)
};

/**

* @param {Tea_Purchase_State_DriedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_state_dried = /** @type {((inputs?: Tea_Purchase_State_DriedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_State_DriedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_state_dried(inputs)
});